import "./styles/Messages.scss";

export type MessageType = `error` | `info` | `warning`;

type Props = {
  label?: string;
  type?: MessageType;
  message?: string;
  messages?: string[];
}

const Messages = ({ label, message, messages, type = `info` }: Props) => {
  if (messages?.length === 1) {
    message = messages[0];
    messages = undefined;
  }

  return (
    <div
      role="alert"
      aria-label={ label || type }
      className={ `ws-widgets-messages ws-widgets-messages--${ type }` }>
      { message && <div dangerouslySetInnerHTML={ { __html: message } } /> }
      { messages &&
        <ul>
          {
            Object.values(messages).map((message, index) => {
              return <li key={ index }>{ message }</li>
            })
          }
        </ul>
      }
    </div>
  )
}

export default Messages;
